module.exports = "/images/author2.jpg?d2f9e40507a849b37f629fc34543f171";


//////////////////
// WEBPACK FOOTER
// ./resources/images/author2.jpg
// module id = ISCM
// module chunks = 2